import { render, staticRenderFns } from "./SurveyThankyouInfo.vue?vue&type=template&id=2f3afd7a&"
import script from "./SurveyThankyouInfo.vue?vue&type=script&lang=js&"
export * from "./SurveyThankyouInfo.vue?vue&type=script&lang=js&"
import style0 from "./SurveyThankyouInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports